<template>
  <div id="main">
    <section id="about" class="about">
      <div class="container">
        <div class="section-title">
          <h2>About</h2>
          <div class="previous-section float-left">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/services"
              role="button"
              >Go to Previous Section</a
            >
          </div>
          <div class="next-section float-right">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/resume"
              role="button"
              >Go to Next Section</a
            >
          </div>
        </div>
        <div class="col-lg-12 pt-lg-0 content" data-aos="fade-left">
          <p>
            Jotweb is a team of designers and developers involoved in ux/UI
            design, full stack web development and data analysis.
          </p>
          <p>
            We specialize on using PHP or Laravel framework and MYSQL Database
            for backend web development while HTML5, CSS3, JavaScript / Vuejs /
            Angularjs for frontend web development.
          </p>
          <p>
            In addition, Our team make use of Python, Eview and Spss for Data
            analysis depending on customers' demand.
          </p>
        </div>
      </div>
    </section>
    <!-- End About Section -->

    <!-- ======= Skills Section ======= -->
    <section
      id="skills"
      class="skills section-bg"
      data-aos="slide-up"
      data-aos-easing="ease"
    >
      <div class="container">
        <div class="section-title">
          <h2>Skills</h2>
          <p>We have proficient skills in the following technologies:</p>
        </div>

        <div class="row skills-content">
          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <div class="progress">
              <span class="skill">HTML <i class="val">100%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="100"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill"> CSS <i class="val">90%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="90"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill">JavaScript <i class="val">80%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="75"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill">VueJs <i class="val">85%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="80"
              ></progress-bar>
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <div class="progress">
              <span class="skill">PHP/LARAVEL<i class="val">95%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="95"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill">WordPress/CMS <i class="val">95%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="95"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill">UX/UI Design <i class="val">70%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="70"
              ></progress-bar>
            </div>
            <div class="progress">
              <span class="skill">Data Analysis<i class="val">85%</i></span>
              <progress-bar
                size="large"
                bar-color="#150cb7"
                val="85"
              ></progress-bar>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Skills Section -->
  </div>
</template>

<script>
import ProgressBar from "vue-simple-progress";

export default {
  name: "About",
  components: {
    ProgressBar
  }
};
</script>
